import React, { Component } from "react";
import clsx from "clsx";
import { TextField } from "@material-ui/core";
import { Button, Tooltip } from "@material-ui/core";
import { FaUndo } from "react-icons/fa";
import { connect } from "react-redux";

class BulkEditTextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialErrors: props.errors,
      updatedError: "",
    };
  }

  handleInputChange = (event) => {
    const { handleChange, maxLength, type } = this.props;
    let { value } = event.target;
    if (event.target.value.length <= maxLength) {
      event.target.value = value;
      handleChange(event);
    } else {
      handleChange(event);
    }
  };

  handleRefresh = () => {
    const { refreshOnClick } = this.props;
    refreshOnClick();
  };

  render() {
    const {
      classes,
      errors,
      title,
      titleClass,
      name,
      type,
      value,
      variant,
      disabled,
      selectOnFocus,
      inputProps,
      onFocusEvent,
      onKeyDownEvent,
      onPressEnterKeySearch,
      onBlurEvent,
      label = "",
      placeholder = "",
      multiline,
      maxLength,
      rows = "",
      refreshDisabled,
      isRequired,
      isAppend,
    } = this.props;
    const { updatedError } = this.state;

    return (
      <>
        <label className={classes.globalCreateLabel} htmlFor={title}>
          {title}
          {isRequired && (
            <span aria-label="Name required" className={classes.reqSymbol}>
              {" "}
              *{" "}
            </span>
          )}
          {isAppend && (
            <span className={clsx(classes.append_text_color)}>
              <b> +</b>{" "}
            </span>
          )}
        </label>
        <span>:</span>
        <div className="flexItem">
          <TextField
            name={name}
            aria-label={title}
            type={type}
            label={label}
            disabled={disabled}
            autoFocus={selectOnFocus}
            variant={variant || "outlined"}
            className={clsx(classes.tableFilterInput, classes.root)}
            helperText={(errors && errors[name]) || updatedError || ""}
            error={(errors && errors[name]) || updatedError ? true : false}
            value={value}
            multiline={multiline}
            maxLength={maxLength}
            rows={rows}
            placeholder={placeholder}
            onChange={this.handleInputChange}
            InputLabelProps={{
              classes: {
                root: classes.tableInputLabel,
                focused: classes.tableInputFocused,
              },
            }}
            inputProps={{
              readOnly: disabled,
              classes: {
                root: classes.tableInputOutlinedInput,
                focused: classes.tableInputFocused,
                notchedOutline: classes.tableNotchedOutline,
              },
              inputProps,
            }}
            onFocus={(event) => {
              if (selectOnFocus) {
                event.target.select();
              }
              if (onFocusEvent) {
                onFocusEvent();
              }
            }}
            onKeyUp={(event) => {
              event.stopPropagation();
            }}
            onKeyPress={(event) => {
              event.stopPropagation();
            }}
            onKeyDown={(event) => {
              event.stopPropagation();

              if (onKeyDownEvent) {
                onKeyDownEvent();
              }
              if (onPressEnterKeySearch && event.key === "Enter") {
                onPressEnterKeySearch();
              }
            }}
            onBlur={(event) => {
              if (onBlurEvent) {
                onBlurEvent(event);
              }
            }}
          />
          {!refreshDisabled && (
            <Tooltip title={"Reset to default value"}>
              <Button
                aria-label={name}
                id={name}
                name={name}
                //disabled={refreshDisabled}
                onClick={this.handleRefresh}
                className={classes.resetButton}>
                <FaUndo style={{ fontSize: "10px" }} />
              </Button>
            </Tooltip>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.bulkEdit,
});

export default connect(mapStateToProps)(BulkEditTextInput);
